export enum Perms {
  READ_COMPANIES = 'read:companies',
  READ_COMPANY = 'read:company'
}

export interface PermissionsState {
  readCompany: boolean;
  readCompanies: boolean;
  isZonarUser: boolean;
  companies: any[];
  divisions: any[];
  // locations: any[];
  requestStartTime?: number;
}

export const initialPermissionsState: PermissionsState = {
  readCompanies: false,
  readCompany: false,
  isZonarUser: false,
  companies: [],
  divisions: [],
  // locations: [],
  requestStartTime: 0
};
